import { CircularProgress } from '@mui/material'
import React from 'react'

function ErrorState() {
  return (
      <div className='flex justify-center h-full align-middle items-center w-full'>
        <p className='text-slate-800 text-[10pt]'> Erro inesperado, entre em contato com um administrador</p>
      </div>
  )
}

export default ErrorState